// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__S1Py2"};